<template>
  <div class="dashboard-box-cla">
    <div class="title-cla">Smart DBS</div>
    <!-- <div class="time-bar-cla">
      <span @click="trigerFullScreen" class="number-cla">{{ year }}</span>
      <span class="time-lable-cla">年</span>
      <span class="number-cla">{{ months }}</span>
      <span class="time-lable-cla">月</span>
      <span class="number-cla">{{ date }}</span>
      <span class="time-lable-cla">日</span>
      <span style="margin:0px 31px;" class="number-cla">{{ week }}</span>
      <span class="number-cla">{{ time }}</span>
    </div> -->
    <div class="map-chart-box-cla">
      <chinaChar></chinaChar>
    </div>

    <!-- <div class="right-char-box">
      <div class="sub-char-box">
        <div class="title-tip-cla">
          日活统计
          <div class="line-cla"></div>
        </div>
        <div class="pie-chart-cla">
          <pieChar></pieChar>
          <pieChar></pieChar>
        </div>
      </div>
      <div class="sub-char-box">
        <div class="title-tip-cla">
          数据统计
          <div class="line-cla"></div>
        </div>
        <statistical></statistical>
      </div>
      <div class="sub-char-box">
        <div class="title-tip-cla">
          设备类型TOP10
          <div class="line-cla"></div>
        </div>
        <sortBar></sortBar>
      </div>
    </div> -->
  </div>
</template>

<script>
import chinaChar from './china/chinaChar'
import pieChar from './pie/pieChar'
import statistical from './statistical/statistical'
import sortBar from './sortBar/sortBar'
import { dateFormat } from '@/utils/utils.js'
export default {
  data() {
    return {
      year: '',
      months: '',
      date: '',
      week: '',
      time: '',
      timer: null,
      timeout: null,
      isFull: false
    }
  },
  mounted() {
    this.timer = setInterval(() => {
      this.getTime()
    }, 100000)
    let isFull = this.getIsFull()
    document.body.style.zoom = this.getHeight() / (isFull ? 1200 : 1095)
    window.addEventListener('resize', this.listenResize.bind(this), true)
  },

  methods: {
    getTime() {
      let current = new Date()
      this.year = current.getFullYear()
      this.months = current.getMonth()
      this.date = current.getDate()
      this.week = this.getWeek(current.getDay())
      this.time = dateFormat(current, 'HH:mm:ss')
    },
    getWeek(key) {
      var week = ''
      switch (key) {
        case 0:
          week = '星期日'
          break
        case 1:
          week = '星期一'
          break
        case 2:
          week = '星期二'
          break
        case 3:
          week = '星期三'
          break
        case 4:
          week = '星期四'
          break
        case 5:
          week = '星期五'
          break
        case 6:
          week = '星期六'
          break
      }
      return week
    },

    trigerFullScreen() {
      if (
        document.webkitIsFullScreen ||
        document.mozFullScreen ||
        document.msFullscreenElement ||
        document.fullscreenElement
      ) {
        this.exitFullscreen()
      } else {
        this.fullScreen(0)
      }
    },

    getIsFull() {
      let isFull =
        !!(
          document.webkitIsFullScreen ||
          document.mozFullScreen ||
          document.msFullscreenElement ||
          document.fullscreenElement
        ) || document.body.offsetHeight >= window.screen.height
      this.isFull = isFull
      return isFull
    },

    // 全屏
    fullScreen() {
      var element = document.documentElement
      if (element.requestFullscreen) {
        element.requestFullscreen()
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen()
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen()
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen()
      }
    },
    // 退出全屏
    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen()
      }
    },

    listenResize() {
      if (this.timeout) {
        clearTimeout(this.timeout)
      }
      this.timeout = setTimeout(
        function() {
          let isFull = this.getIsFull()
          let height = this.getHeight()
          document.body.style.zoom = height / (isFull ? 1200 : 1095)
        }.bind(this),
        500
      )
    },
    getHeight() {
      return document.body.offsetHeight > window.screen.height
        ? window.screen.height
        : document.body.offsetHeight
    }
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.listenResize)
    if (this.timer) {
      clearInterval(this.timer)
    }
  },

  components: {
    chinaChar,
    pieChar,
    statistical,
    sortBar
  }
}
</script>
<style scoped lang="less">
.dashboard-box-cla {
  height: 100%;
  width: 100%;
  overflow: hidden;
  background-image: linear-gradient(#20303e, #040f1f);
  position: relative;
  .title-cla {
    position: absolute;
    left: 0px;
    top: 20px;
    width: 379px;
    height: 100px;
    line-height: 100px;
    background: rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.4);
    border-left: none;
    border-radius: 0px 50px 50px 0px;
    font-size: 50px;
    font-family: FZHei-B01S;
    font-weight: bold;
    color: #ffffff;
    z-index: 100;
    padding-left: 40px;
    box-sizing: border-box;
  }
  .time-bar-cla {
    position: absolute;
    right: 0px;
    top: 20px;
    width: 646px;
    height: 73px;
    line-height: 73px;
    background: rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.4);
    border-right: none;
    border-radius: 50px 0px 0px 50px;
    font-size: 50px;
    font-family: FZHei-B01S;
    font-weight: bold;
    color: #ffffff;
    z-index: 100;
    padding-left: 40px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    .number-cla {
      font-size: 32px;
      font-family: "Let's go Digital";
      font-weight: bold;
      color: #c9d3f5;
    }
    .time-lable-cla {
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      margin: 0px 10px;
      color: #527fb5;
      position: relative;
      top: 2px;
    }
  }
}

.map-chart-box-cla {
  position: relative;
  width: 1920px;
  height: 1080px;
  // transform: scale(0.98, 0.98);
  border-radius: 30%;
  background-size: cover;
  left: -10px;
  top: 0px;
  background-image: url('~@/assets/chart/img_bg.jpg');
}

.right-char-box {
  position: absolute;
  right: 0px;
  top: 0px;
  width: 550px;
  padding-top: 150px;
  box-sizing: border-box;
  height: 100%;
  .sub-char-box {
    height: 33%;
    .pie-chart-cla {
      display: flex;
      justify-content: space-around;
      margin-top: 20px;
    }
    .title-tip-cla {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
      padding-left: 13px;
      display: flex;
      align-items: center;
      position: relative;
      width: 90%;
      height: 30px;
      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 20%;
        height: 60%;
        width: 3px;
        background: linear-gradient(0deg, #4694ff 0%, #42c3ff 100%);
      }
      .line-cla {
        margin-left: 10px;
        height: 1px;
        border-top: 1px dashed rgba(255, 255, 255, 0.7);
        flex-grow: 1;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/dashboard/index.vue